import { gql } from 'apollo-boost'

const START_SCRAPING_SESSION_DUPLICATE = gql`
  mutation startScrapingSessionDuplicateOfId(
    $id: ID!
    $isDebugModeScraping: Boolean!
    $scrapingType: ScrapingType
    $scrapingSettings: Object
  ) {
    startScrapingSessionDuplicateOfId(
      id: $id
      isDebugModeScraping: $isDebugModeScraping
      scrapingType: $scrapingType
      scrapingSettings: $scrapingSettings
    )
  }
`

export default START_SCRAPING_SESSION_DUPLICATE
